import { render, staticRenderFns } from "./ImageResourceFileUpload.vue?vue&type=template&id=60c2eae0&"
import script from "./ImageResourceFileUpload.vue?vue&type=script&lang=js&"
export * from "./ImageResourceFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c2eae0')) {
      api.createRecord('60c2eae0', component.options)
    } else {
      api.reload('60c2eae0', component.options)
    }
    module.hot.accept("./ImageResourceFileUpload.vue?vue&type=template&id=60c2eae0&", function () {
      api.rerender('60c2eae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/others/image-resource-manage/ImageResourceFileUpload.vue"
export default component.exports